// AppContext.js
import React, {
  createContext,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import moment from "moment";
import { MyDomain } from "./App";

// Create the context
export const AppContext = createContext();
// Create a provider component
export const AppProvider = ({ children }) => {
  const [User, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || null;
    } catch {
      return null;
    }
  });
  const [Lang, setLang] = useState(
    JSON.parse(localStorage.getItem("lang")) || "he"
  );
  const [favCount, setFavCount] = useState(0);
  const [favIds, setFavIds] = useState(new Set());
  const [cartItems, setCartItems] = useState({});

  const cartCount = Object.values(cartItems).reduce((s, v) => s + v, 0);

  useEffect(() => {
    if (!User?.id) return;

    fetch(`${MyDomain}Products2/GetUserFavorites`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: User.id }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setFavIds(new Set(data.map((f) => f.productId)));
          setFavCount(data.length);
        }
      })
      .catch(() => {});

    fetch(`${MyDomain}Products2/GetUserCart`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: User.id }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const map = {};
          data.forEach((item) => { map[item.productId] = item.amount; });
          setCartItems(map);
        }
      })
      .catch(() => {});
  }, [User]);

  const removeUser = () => {
    try {
      localStorage.removeItem("User");
      setUser(null);
      console.log("✅ User removed!");
    } catch (e) {
      console.error("❌ Failed to remove user", e);
    }
  };

  return (
    <AppContext.Provider
      value={{
        User,
        setUser,
        Lang,
        setLang,
        favCount,
        setFavCount,
        favIds,
        setFavIds,
        cartItems,
        setCartItems,
        cartCount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export const useAppContext = () => useContext(AppContext);
